export const EXPORT_DATA_OPTIONS = [
  {
    label: 'Download',
    value: 'Download',
  },
  {
    label: 'Send to email',
    value: 'Send to email',
  },
];

export const EXPORT_DATA_OPTIONS_SYNAR = [
  {
    label: 'Download .csv',
    value: 'Download .csv',
  },
  {
    label: 'Download .xls',
    value: 'Download .xls',
  },
  {
    label: 'Send .csv to email',
    value: 'Send .csv to email',
  },
  {
    label: 'Send .xls to email',
    value: 'Send .xls to email',
  },
];

export const EXPORT_DATA_OPTIONS_NAMES = {
  DOWNLOAD: 'Download',
  EMAIL: 'Send to email',
  DOWNLOAD_CSV: 'Download .csv',
  DOWNLOAD_XLS: 'Download .xls',
  EMAIL_CSV: 'Send .csv to email',
  EMAIL_XLS: 'Send .xls to email',
};
